import { useEffect, useState } from "react";
import { Status } from "../lib/globalEnums";
import Spinner from "./Spinner";
import fetchService from "../lib/fetchService";

let searchTimeout: NodeJS.Timeout | undefined

export default function SearchField(props: {

}) {
  const [functionalClass, setFunctionalClass] = useState('');
  const [needle, setNeedle] = useState('');
  const [results, setResults] = useState<{name: string, link: string}[]>([] as {name: string, link: string}[]);
  const [status, setStatus] = useState(Status.ready);
  async function onNeedleChange(needle: string) {
    setNeedle(needle);
    setFunctionalClass(needle ? ' w3-show' : '');
    if (needle) {
      clearTimeout(searchTimeout);
      searchTimeout = setTimeout(async () => {
        setStatus(Status.loading);
        fetchService.post('/api/search', {needle: needle}).then((data) => {
          setResults(data);
          setStatus(Status.ready);
        })
      }, 500);
    }
  }
  return <div className="w3-dropdown-click">
    <input className='w3-input w3-border' type="search" placeholder="Suche" value={needle} onChange={(e) => {
      const needle = e.target.value;
      onNeedleChange(needle);
    }} />
    <div className={"w3-dropdown-content w3-bar-block w3-border" + functionalClass} style={{right: 0}}>
      {
        results.map((result) => {
          return <a key={result.link} href={result.link} className="w3-bar-item w3-button">{result.name}</a>
        })
      }
      {
        status === Status.loading && <div className="w3-bar-item w3-button"><Spinner /></div>
      }
      {
        status !== Status.loading && results.length === 0 && <div className="w3-bar-item w3-button">Keine Ergebnisse</div>
      }
    </div>
  </div>
}